import { SET_PERMISSIONS_SEARCH_PARAMS } from 'src/actions/actionType'
import { INITIAL_PERMISSIONS_SEARCH_PARAMS } from 'src/views/security/permissions/partials/Constants'

const initialState = {
  searchParams: INITIAL_PERMISSIONS_SEARCH_PARAMS,
}

export default function PermissionsReducer(state = initialState, action) {
  switch (action.type) {
    case SET_PERMISSIONS_SEARCH_PARAMS:
      return {
        ...state,
        searchParams: action.payload,
      }
    default:
      return state
  }
}
